<template>
  <div class="container align-items-center d-flex flex-column mt-4">
    <h2
      class="supported-devices-title"
      v-html="$t('freemium.supportedDevices.title')"
    ></h2>
    <div class="supported-devices-content">
      <p class="mb-4" v-html="$t('freemium.supportedDevices.content')"></p>
      <img v-if="mobile" src="@/assets/img/freemium/platforms-mobile.svg" />
      <img v-else src="@/assets/img/freemium/platforms.svg" />
      <router-link
          class="btn btn-danger btn-get-started d-block my-5 mx-auto"
          :to="{ name: 'register' }"
          v-if="mobile"
      >
        {{ $t("freemium.supportedDevices.cta") }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    mobile() {
      return this.isMobile();
    },
  },
};
</script>

<style lang="scss" scoped>
.supported-devices-title {
  text-align: center;
  margin-top: 32px;
}
.supported-devices-content {
  text-align: center;
  margin-top: 32px;
  margin-bottom: 32px;
}
</style>
